import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3079cfb3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "trade-from"
};
const _hoisted_2 = {
  class: "balance"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  class: "custom-label"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "custom-suffix"
}, "USDT", -1));
const _hoisted_9 = {
  key: 1,
  style: {
    "height": "46px",
    "margin-bottom": "16px",
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center"
  }
};
const _hoisted_10 = {
  key: 2,
  class: "custom-input",
  style: {
    "text-align": "center"
  }
};
const _hoisted_11 = {
  class: "custom-label"
};
const _hoisted_12 = {
  class: "custom-suffix"
};
const _hoisted_13 = {
  key: 3,
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "margin": "-10px 0 10px 0"
  }
};
const _hoisted_14 = {
  key: 4,
  style: {
    "padding-top": "22px"
  }
};
const _hoisted_15 = {
  class: "custom-label"
};
const _hoisted_16 = {
  class: "custom-suffix"
};
const _hoisted_17 = {
  key: 5,
  style: {
    "color": "#03ad73"
  }
};
const _hoisted_18 = {
  key: 6,
  style: {
    "padding": "5px 0 20px 0"
  }
};
const _hoisted_19 = {
  key: 7,
  class: "contract-input"
};
const _hoisted_20 = {
  class: "custom-label"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "custom-suffix"
}, "USDT", -1));
const _hoisted_22 = {
  class: "custom-label"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "custom-suffix"
}, "USDT", -1));
import { ref, reactive, watch } from 'vue';
import store from '@/store';
import BigNumber from 'bignumber.js';
import { useI18n } from 'vue-i18n';
import { fmtNumber } from '@/util';
export default {
  __name: 'TradeForm',
  props: {
    useNum: {
      type: String,
      default: '0.00'
    },
    useStock: {
      type: String,
      default: '--'
    },
    stock: {
      type: String,
      default: '--'
    },
    bg: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: '--'
    },
    tradeType: {
      type: Number,
      default: 0
    },
    kline: {
      type: String,
      default: ''
    },
    side: {
      type: String,
      default: 'buy'
    },
    contract: {
      type: Boolean,
      default: false
    },
    ieo: {
      type: Number,
      default: 0
    },
    // 0 默认 1 ieo买入 2 ieo 服务账户
    disabled: {
      type: Boolean,
      default: false
    },
    fee: {
      type: Number,
      default: 0
    },
    sliderShow: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Number,
      default: 1
    },
    useText: {
      type: String,
      default: 'useable'
    },
    useIeo: {
      type: String,
      default: ''
    },
    cntScale: {
      type: String,
      default: '0'
    },
    sellScale: {
      type: Number,
      default: 0
    },
    index: {
      type: Number,
      default: 0
    }
  },
  emits: ['commit', 'ieoChange', 'serviceChange'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    watch(() => props.tradeType, () => {
      if (store.state.market[props.kline]) {
        form.price = store.state.market[props.kline].last;
      }
    });
    const totalRate = ref(0);
    const marks = ref({
      0: '0%',
      25: '25%',
      50: '50%',
      75: '75%',
      100: '100%'
    });
    const form = reactive({
      price: '',
      number: '',
      total: '',
      tpPrice: '',
      // 止盈
      slPrice: '',
      // 止损
      ieo: 'USDT',
      service: 0 // 0 锁定价格 1 自由价格
    });

    const priceInput = ref(false);
    const numberInput = ref(false);
    const totalInput = ref(false);
    const getFee = () => {
      if (!form.total || form.total <= 0) {
        return 0;
      }
      const fee = BigNumber(props.useNum).multipliedBy(props.fee).multipliedBy(props.multiple).toNumber();
      const max = BigNumber(props.useNum).minus(fee).toNumber();
      if (max === form.total) {
        return fmtNumber(BigNumber(props.useNum).multipliedBy(props.fee).multipliedBy(props.multiple).toFixed(2));
      }
      return fmtNumber(BigNumber(form.total).multipliedBy(props.fee).multipliedBy(props.multiple).toFixed(2));
    };
    const ieoChange = type => {
      form.number = '';
      form.total = '';
      form.ieo = type;
      emit('ieoChange', type);
    };
    const commit = () => {
      const fee = BigNumber(props.useNum).multipliedBy(props.fee).multipliedBy(props.multiple).toNumber();
      const max = BigNumber(props.useNum).minus(fee).toNumber();
      emit('commit', {
        ...form,
        side: props.side,
        max: max
      });
    };
    watch(() => form.price, () => {
      if (Number(form.price) < 0) {
        form.price = 0;
      }
      if (priceInput.value && Number(form.price) > 0 && form.total !== '') {
        let decimal = 8;
        if (store.state.marketInfo[props.kline] && store.state.marketInfo[props.kline].decimal > 8) {
          decimal = store.state.marketInfo[props.kline].decimal;
        }
        form.number = Number(BigNumber(form.total).dividedBy(form.price).toFixed(decimal));
      }
    });
    watch(() => form.number, () => {
      if (totalInput.value || numberInput.value) {
        if (!props.contract && props.side === 'sell') {
          const fee = BigNumber(props.useNum).multipliedBy(props.fee).multipliedBy(props.multiple).toNumber();
          const max = BigNumber(props.useNum).minus(fee).toNumber();
          if (form.total < 0) {
            totalRate.value = 0;
          } else if (form.number > max) {
            totalRate.value = 100;
          } else {
            totalRate.value = Number(BigNumber(form.number).dividedBy(max).multipliedBy(100).toFixed(0));
          }
        }
      }
      if (numberInput.value) {
        const num = Number(form.number);
        if (num < 0) {
          form.number = 0;
        }
        let decimal = 8;
        if (store.state.marketInfo[props.kline] && store.state.marketInfo[props.kline].decimal > 8) {
          decimal = store.state.marketInfo[props.kline].decimal;
        }
        if (form.ieo !== 'USDT') {
          const cntKey = `${form.ieo}USDT`;
          if (store.state.market[cntKey]) {
            const last = store.state.market[props.kline] ? store.state.market[props.kline].last : 0;
            form.total = BigNumber(form.number).multipliedBy(last).dividedBy(store.state.market[cntKey].last).toFixed(8);
          } else {
            form.total = 0;
          }
        } else {
          if (props.tradeType === 0) {
            // 市价
            const price = store.state.market[props.kline] ? Number(store.state.market[props.kline].last) : 0;
            if (form.number) {
              form.total = Number(BigNumber(price).multipliedBy(form.number).toFixed(decimal));
            }
          } else {
            // 限价
            if (form.price && form.number) {
              form.total = Number(BigNumber(form.price).multipliedBy(form.number).toFixed(decimal));
            }
          }
        }
        if (Number(props.cntScale) > 0) {
          form.total = BigNumber(form.total).multipliedBy(props.cntScale).toFixed(decimal);
        } else if (props.sellScale > 0) {
          form.total = BigNumber(form.total).multipliedBy(props.sellScale).toFixed(decimal);
        }
      }
      if (form.number === '' && form.total) {
        form.total = '';
      }
    });
    watch(() => form.total, () => {
      if (totalInput.value || numberInput.value) {
        if (props.contract || props.side === 'buy') {
          const fee = BigNumber(props.useNum).multipliedBy(props.fee).multipliedBy(props.multiple).toNumber();
          const max = BigNumber(props.useNum).minus(fee).toNumber();
          if (form.total < 0) {
            totalRate.value = 0;
          } else if (form.total > max) {
            totalRate.value = 100;
          } else {
            totalRate.value = Number(BigNumber(form.total).dividedBy(max).multipliedBy(100).toFixed(0));
          }
        }
      }
      if (totalInput.value) {
        const totalNum = Number(form.total);
        if (totalNum < 0) {
          form.total = 0;
        }
        let decimal = 8;
        if (store.state.marketInfo[props.kline] && store.state.marketInfo[props.kline].decimal > 8) {
          decimal = store.state.marketInfo[props.kline].decimal;
        }
        if (form.ieo !== 'USDT') {
          const cntKey = `${form.ieo}USDT`;
          if (store.state.market[props.kline]) {
            const last = store.state.market[cntKey] ? store.state.market[cntKey].last : 0;
            form.number = BigNumber(form.total).multipliedBy(last).dividedBy(store.state.market[props.kline].last).toFixed(8);
          } else {
            form.number = 0;
          }
        } else {
          if (props.tradeType === 0) {
            // 市价
            const price = store.state.market[props.kline] ? Number(store.state.market[props.kline].last) : 0;
            if (form.total && price > 0) {
              form.number = BigNumber(form.total).dividedBy(price).toFixed(decimal);
            }
          } else {
            // 限价
            if (form.total && form.price && form.price > 0) {
              form.number = Number(BigNumber(form.total).dividedBy(form.price).toFixed(decimal));
            } else {
              if (form.total && form.number && form.number > 0) {
                form.price = Number(BigNumber(form.total).dividedBy(form.number).toFixed(decimal));
              }
            }
          }
        }
        if (form.total === '' && form.number) {
          form.number = '';
        }
      }
    });
    const rateChange = value => {
      const total = Number(BigNumber(props.useNum).multipliedBy(value).dividedBy(100).toFixed(8));
      const fee = BigNumber(props.useNum).multipliedBy(props.fee).multipliedBy(props.multiple).toNumber();
      const max = BigNumber(props.useNum).minus(fee).toNumber();
      if (!props.contract && props.side === '1') {
        // 币币交易的卖出
        if (total < 0) {
          form.number = 0;
        } else if (total > max) {
          form.number = max;
        } else {
          form.number = total;
        }
        if (form.number > 0) {
          if (props.tradeType === 0) {
            const price = store.state.market[props.kline] ? Number(store.state.market[props.kline].last) : 0;
            form.total = BigNumber(form.number).multipliedBy(price).toFixed(8);
          } else {
            if (form.price > 0) {
              form.total = BigNumber(form.number).multipliedBy(form.price).toFixed(8);
            }
          }
        }
      } else {
        if (total < 0) {
          form.total = 0;
        } else if (total > max) {
          form.total = max;
        } else {
          form.total = total;
        }
        if (form.total > 0) {
          if (props.tradeType === 0) {
            const price = store.state.market[props.kline] ? Number(store.state.market[props.kline].last) : 0;
            form.number = BigNumber(form.total).dividedBy(price).toFixed(8);
          } else {
            if (form.price > 0) {
              form.number = BigNumber(form.total).dividedBy(form.price).toFixed(8);
            }
          }
        }
      }
    };
    const clear = () => {
      form.number = '';
      form.price = '';
      form.slPrice = '';
      form.tpPrice = '';
      form.total = '';
      totalRate.value = 0;
    };
    expose({
      clear
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_slider = _resolveComponent("a-slider");
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [props.index == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(t)('currencyAccount')), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(t)('contractAccount')), 1)), _createElementVNode("span", null, [_createTextVNode(_toDisplayString(props.useNum) + " ", 1), props.ieo === 2 ? (_openBlock(), _createElementBlock("span", _hoisted_5, "ERS")) : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(props.useStock), 1))])]), __props.tradeType === 1 ? (_openBlock(), _createBlock(_component_a_input, {
        key: 0,
        class: "custom-input",
        bordered: false,
        value: form.price,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => form.price = $event),
        onFocus: _cache[1] || (_cache[1] = $event => priceInput.value = true),
        onBlur: _cache[2] || (_cache[2] = $event => priceInput.value = false),
        type: "number"
      }, {
        prefix: _withCtx(() => [_createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('price')), 1)]),
        suffix: _withCtx(() => [_hoisted_8]),
        _: 1
      }, 8, ["value"])) : _createCommentVNode("", true), props.ieo === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_a_button, {
        type: form.ieo === 'USDT' ? 'primary' : '',
        onClick: _cache[3] || (_cache[3] = $event => ieoChange('USDT')),
        style: {
          "width": "24%",
          "height": "46px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(" USDT ")]),
        _: 1
      }, 8, ["type"]), _createVNode(_component_a_button, {
        type: form.ieo === 'USDC' ? 'primary' : '',
        onClick: _cache[4] || (_cache[4] = $event => ieoChange('USDC')),
        style: {
          "width": "24%",
          "height": "46px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(" USDC ")]),
        _: 1
      }, 8, ["type"]), _createVNode(_component_a_button, {
        type: form.ieo === 'BTC' ? 'primary' : '',
        onClick: _cache[5] || (_cache[5] = $event => ieoChange('BTC')),
        style: {
          "width": "24%",
          "height": "46px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(" BTC ")]),
        _: 1
      }, 8, ["type"]), _createVNode(_component_a_button, {
        type: form.ieo === 'ETH' ? 'primary' : '',
        onClick: _cache[6] || (_cache[6] = $event => ieoChange('ETH')),
        style: {
          "width": "24%",
          "height": "46px"
        }
      }, {
        default: _withCtx(() => [_createTextVNode(" ETH ")]),
        _: 1
      }, 8, ["type"])])) : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(t)('optimal')), 1)), _withDirectives(_createVNode(_component_a_input, {
        class: "custom-input",
        bordered: false,
        value: form.number,
        "onUpdate:value": _cache[7] || (_cache[7] = $event => form.number = $event),
        onFocus: _cache[8] || (_cache[8] = $event => numberInput.value = true),
        onBlur: _cache[9] || (_cache[9] = $event => numberInput.value = false),
        type: "number"
      }, {
        prefix: _withCtx(() => [_createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('number')), 1)]),
        suffix: _withCtx(() => [_createElementVNode("span", _hoisted_12, _toDisplayString(props.stock), 1)]),
        _: 1
      }, 8, ["value"]), [[_vShow, props.index == 0]]), props.useIeo !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("span", null, _toDisplayString(_unref(t)('useable')), 1), _createElementVNode("span", null, _toDisplayString(props.useNum) + " ERS", 1)])) : props.ieo ? (_openBlock(), _createElementBlock("div", _hoisted_14)) : _createCommentVNode("", true), _createVNode(_component_a_input, {
        class: "custom-input",
        bordered: false,
        value: form.total,
        "onUpdate:value": _cache[10] || (_cache[10] = $event => form.total = $event),
        onFocus: _cache[11] || (_cache[11] = $event => totalInput.value = true),
        onBlur: _cache[12] || (_cache[12] = $event => totalInput.value = false),
        type: "number"
      }, {
        prefix: _withCtx(() => [_createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)('tradeVol')), 1)]),
        suffix: _withCtx(() => [_createElementVNode("span", _hoisted_16, _toDisplayString(form.ieo), 1)]),
        _: 1
      }, 8, ["value"]), props.fee > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(t)('fee')) + "：" + _toDisplayString(getFee()), 1)) : _createCommentVNode("", true), props.sliderShow ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_component_a_slider, {
        value: totalRate.value,
        "onUpdate:value": _cache[13] || (_cache[13] = $event => totalRate.value = $event),
        marks: marks.value,
        onChange: rateChange
      }, null, 8, ["value", "marks"])])) : _createCommentVNode("", true), props.contract ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_component_a_input, {
        class: "custom-input",
        style: {
          "margin-right": "10px"
        },
        bordered: false,
        value: form.tpPrice,
        "onUpdate:value": _cache[14] || (_cache[14] = $event => form.tpPrice = $event),
        type: "number"
      }, {
        prefix: _withCtx(() => [_createElementVNode("span", _hoisted_20, _toDisplayString(_unref(t)('tp')), 1)]),
        suffix: _withCtx(() => [_hoisted_21]),
        _: 1
      }, 8, ["value"]), _createVNode(_component_a_input, {
        class: "custom-input",
        bordered: false,
        value: form.slPrice,
        "onUpdate:value": _cache[15] || (_cache[15] = $event => form.slPrice = $event),
        type: "number"
      }, {
        prefix: _withCtx(() => [_createElementVNode("span", _hoisted_22, _toDisplayString(_unref(t)('sl')), 1)]),
        suffix: _withCtx(() => [_hoisted_23]),
        _: 1
      }, 8, ["value"])])) : _createCommentVNode("", true), _createVNode(_component_van_button, {
        class: "trade-btn",
        onClick: commit,
        disabled: props.disabled,
        style: _normalizeStyle({
          '--bg': props.bg,
          color: '#fff'
        })
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(props.text), 1)]),
        _: 1
      }, 8, ["disabled", "style"])]);
    };
  }
};